import type { CabinBaggageTripSummary } from '@eti/schema-types';
import { CabinBaggageStatus } from '@eti/schema-types';
import { useTranslation } from '@eti/providers';
import { getIncludedBaggageText } from '../utils/getIncludedBaggageText';

const useGetPersonalAndCabinBaggageInfo = (
  isPersonalItemIncluded: boolean,
  cabinBaggageTripSummary: CabinBaggageTripSummary,
) => {
  const { t } = useTranslation();
  let personalAndCabinText;
  let isIncluded = true;
  if (
    isPersonalItemIncluded &&
    cabinBaggageTripSummary?.cabinBaggageTravelerDetails[0]?.cabinBaggageStatus ===
      CabinBaggageStatus.IncludedCabinBaggage
  ) {
    personalAndCabinText = getIncludedBaggageText(
      cabinBaggageTripSummary.cabinBaggageTravelerDetails[0].cabinBaggageDetails!,
      'BrandedFares.PersonalItemAndCabinBaggageIncluded.Text',
      t,
    );
  } else if (
    isPersonalItemIncluded &&
    (cabinBaggageTripSummary?.cabinBaggageTravelerDetails[0]?.cabinBaggageStatus ===
      CabinBaggageStatus.NoCabinBaggage ||
      cabinBaggageTripSummary?.cabinBaggageTravelerDetails[0]?.cabinBaggageStatus ===
        CabinBaggageStatus.NoCabinBaggageAvailable)
  ) {
    personalAndCabinText = t('BrandedFares.PersonalItemIncludedButNoCabinBaggage.Text');
  } else if (
    !isPersonalItemIncluded &&
    cabinBaggageTripSummary?.cabinBaggageTravelerDetails[0]?.cabinBaggageStatus ===
      CabinBaggageStatus.IncludedCabinBaggage
  ) {
    personalAndCabinText =
      cabinBaggageTripSummary.cabinBaggageTravelerDetails[0] &&
      getIncludedBaggageText(
        cabinBaggageTripSummary.cabinBaggageTravelerDetails[0].cabinBaggageDetails!,
        'BrandedFares.NoPersonalItemButCabinBaggageIncluded.Text',
        t,
      );
  } else if (
    !isPersonalItemIncluded &&
    (cabinBaggageTripSummary?.cabinBaggageTravelerDetails[0]?.cabinBaggageStatus ===
      CabinBaggageStatus.NoCabinBaggage ||
      cabinBaggageTripSummary?.cabinBaggageTravelerDetails[0]?.cabinBaggageStatus ===
        CabinBaggageStatus.NoCabinBaggageAvailable)
  ) {
    personalAndCabinText = t('BrandedFares.NoPersonalItemAndNoCabinBaggageIncluded.Text');
    isIncluded = false;
  }
  return { isIncluded, personalAndCabinText };
};

export default useGetPersonalAndCabinBaggageInfo;
